













































































































import Vue from 'vue';
import moment from 'moment';

export default Vue.extend({
  name: 'PicDateTime',
  props: {
    time: {
      type: Object,
      required: true
    },
    canDelete: {type: Boolean}
  },
  beforeMount() {
    this.timeStart = moment(this.time.tsStart).format('HH:mm');
    this.timeEnd = moment(this.time.tsEnd).format('HH:mm');
    this.dateStart = moment(this.time.tsStart).format('YYYY-MM-DD');
    this.dateEnd = moment(this.time.tsEnd).format('YYYY-MM-DD');
  },
  data() {
    return {
      showDate1: false,
      showDate2: false,
      showDate3: false,
      showDate4: false,
      timeStart: '',
      dateStart: '',
      timeEnd: '',
      dateEnd: '',
      exportData: {tsStart: '', tsEnd: '', id: this.time.id, ticketCategory: this.time.ticketCategory}
    };
  },
  methods: {
    save() {
      const formatDateStr = (time: string, date: string, targetDate: string) => moment(date)
        .year(moment(date).year())
        .month(moment(date).month())
        .date(moment(date).date())
        .hour(time.split(':')[0] as any)
        .minute(time.split(':')[1] as any).toISOString();

      this.exportData.tsStart = formatDateStr(this.timeStart, this.dateStart, this.exportData.tsStart);
      this.exportData.tsEnd = formatDateStr(this.timeEnd, this.dateEnd, this.exportData.tsEnd);

      this.$emit('saveDate', this.exportData);
    },
    deleteInterval() {
      this.$emit('deleteData', this.exportData);
    }
  }
});
